
:host {
  display: block;
  width: 33.333%;
  height: 25%;
}
